// utils/element-ui/common-components.js
import {
  Main,
  Container,
  Header,
  Col,
  Row,
  Card,
  Menu,
  MenuItem,
  Aside,
  Breadcrumb,
  BreadcrumbItem,
} from 'element-ui'

export default {
  Main,
  Container,
  Header,
  Col,
  Row,
  Card,
  Menu,
  MenuItem,
  Aside,
  Breadcrumb,
  BreadcrumbItem,
}
